import React, { useEffect, useState } from 'react';
import { Button, Modal, Radio, Checkbox, Switch } from 'antd';
import PropagateLoader from "react-spinners/PropagateLoader";
import DataTable from 'react-data-table-component';
import 'antd/dist/antd.css';
import { useHistory } from "react-router-dom";
import { CheckOutlined, CloseOutlined, DeleteOutlined } from '@ant-design/icons';
import ImportBaneficiary from './../moneyTransfer/import';
import { getUser } from "../../Utils/Common";

import {
    GET_FINO_BENEFICIARY_LIST,
    POST_DMT_PAY_SPRINT_CUSTOMER_INFO,
    POST_DMT_PAY_SPRINT_OTP_VERIFICATION,
    POST_DMT_PAY_SPRINT_INITIATE_TRANSACTION,
    POST_DMT_PAY_SPRINT_GENERATE_TRANSACTION,
    POST_DMT_PAY_SPRINT_PAYMENT_TRANSFER,
    POST_FINO_ADD_BENEFICIARY,
    POST_FINO_ADD_BENEFICIARY_OTP,
    UPDATE_DMT_PAY_SPRINT_BENEFICIARY_STATUS,
    UPDATE_DMT_PAY_SPRINT_BENEFICIARY_DETAIL,
    POST_DMT_FAILED_BY_PARTNER,
    GET_DMT_NEW_BANK_LIST,
    GET_CUSTOMER_BANK_NAME_FROM_ACCOUNT_NUMBER,
    IFSC_CODE_VERIFY,
    GET_NAME,
    RE_CHECK,
    POST_FINO_CONFIRM_INITIATE_TRANSACTION,
    POST_FINO_SEND_OTP_TRANSACTION,
    POST_FINO_MAKE_TRANSACTION,
    POST_FINO_DELETE_BENEFICIARY,
    POST_FINO_TRANSACTION_ENQUIRY,
} from '../../Utils/appConstants';
import { getRequest, postRequest } from '../../Utils/AppApi';
import { ToastContainer, toast } from 'react-toastify';
import { isNumber, isAlphabetOnly } from '../../Utils/Common';
import { refId, isIfscCodeValid, getUTCToLocalDateFormat } from './../../Utils/function';
import DmtInvoice from './../../container/dmtInvoice';
import FinoInvoice from "./../../container/finoInvoice";

import Select from 'react-select';

function App(props) {
    const history = useHistory();
    const limit = 10;
    const [getData, setData] = useState([]);
    const [isLimit, setLimit] = useState(limit)
    const [page, setPage] = useState(1);
    const [saveCustomerMobile, setCustomerMobile] = useState(props.customerData && props.customerData.customerMobile);
    const [isLoading, setLoading] = useState(false);
    const [searchText, setSearchText] = useState(null);
    const [getDataField, setDataField] = useState({});
    const [timer, setTimer] = useState(null);
    const [latitude, setLatitude] = useState("");
    const [longitude, setLongitude] = useState("");
    const [bankId, setBankId] = useState(null);
    const [isAddBaneModal, setAddBaneModal] = useState(false);
    const [isSelectedUser, setIsSelectedUser] = useState({});
    const [isSendMoneyModal, setSendMoneyModal] = useState(false);
    const [isSendButtonDisable, setSendButtonDisable] = useState(true);

    const [invoiceDataModal, setInvoiceDataModal] = useState(false);
    const [invoiceData, setInvoiceData] = useState(null);

    const [transactionData, setTransactionData] = useState(null);
    const [transactionId, setTransactionId] = useState(null);
    const [transactionIndex, setTransactionIndex] = useState(0);
    const [transactionSlab, setTransactionSlab] = useState(null);
    const [transactionLength, setTransactionSlabLength] = useState(null);
    const [successTransaction, setSuccessTransaction] = useState([]);

    const [isOtpModal, setOtpModal] = useState(false);
    const [otpCode, setOtpCode] = useState(null)
    const [otpReference, setOtpReference] = useState(null)

    const [sendMoneyAmount, setSendMoneyAmount] = useState([]);
    const [getBeneData, setBeneData] = useState({});
    const [getBeneError, setBeneError] = useState({});
    const [getEKOBankListData, setEKOBankListData] = useState([]);
    const [getBankListData, setBankListData] = useState([{ "value": '', "label": '-- Select Bank --' }]);
    const [selectedOption, setSelectedOption] = useState(null);

    const [isIfscEnable, setIfscEnable] = useState(false);
    const [importModal, setImportModal] = useState(false);
    const [instantTransfer, setInstantTransfer] = useState(false);
    const [instantTransferError, setInstantTransferError] = useState(false);
    const [transactionStatus, setTransactionStatus] = useState(null);
    const [transactionStatusText, setTransactionStatusText] = useState(null);
    const [isOtpTransactionModal, setOtpTransactionModal] = useState(false);
    const [referenceKey, setReferenceKey] = useState(null)
    const [isPaymentStatusModal, setPaymentStatusModal] = useState(false);
    const [chargesData, setChargesData] = useState(null);
    const [bene_id, setBeneID] = useState(null);
    const [bene_auto_id, setBeneAutoId] = useState(null);
    const [channel, setChannel] = useState(2); // 1-IMPS, 2-NEFT
    const [account_number, setAccountNumber] = useState(null);
    const [ifsc_code, setIfscCode] = useState(null);

    const [aadharVerifyModal, setAadharVerifyModal] = useState(false);
    const [aadharVerifyDetail, setAadharVerifyDetail] = useState(null);

    const [beneBankName, setBeneBankName] = useState(null);
    const [recipientName, setRecipientName] = useState(null);
    const [recipientMobile, setRecipientMobile] = useState(null);

    const [selectedRow, setSelectedRow] = useState(null);
    const [showPopup, setShowPopup] = useState(false);

    const openBankSelection = (row) => {
        setSelectedRow(row);
        setShowPopup(true);
    };

    // Added restore beneficiary function
    const restoreBeneficiary = async (row) => {
        setLoading(true);

        // Find the bank from the list
        const findBank = getEKOBankListData.find(item => item.BANK_NAME.toLowerCase() === row.bankName.toLowerCase());

        if (!findBank) {
            toast.error('Bank not found for restoration');
            setLoading(false);
            return;
        }

        const recipientName = (row.beneName && row.beneName.trim() !== '') ? row.beneName : row.beneBankName;

        const payload = {
            customerMobile: saveCustomerMobile,
            recipientMobile: row.beneMobile || '',
            accountNumber: row.accountNumber,
            ifscCode: row.ifscCode,
            bankId: findBank.BankID,
            recipientName: recipientName,
            beneBankName: row.beneBankName,
            beneId: row.beneId,
            action: 'restore',
            latitude: latitude || "0.0",
            longitude: longitude || "0.0",
            devicetype: "W"
        };


        setLoading(true)

        postRequest(`${POST_FINO_ADD_BENEFICIARY_OTP}`, payload, history).then((response) => {
            if (response.success === true) {

                setBankId(findBank.BankID);
                setAccountNumber(row.accountNumber);
                setIfscCode(row.ifscCode);
                setRecipientName(recipientName);
                setBeneID(row.beneId);
                setBeneBankName(row.beneBankName);
                setRecipientMobile(row.beneMobile || '');


                setOtpModal(true);
                setOtpReference(response.data.stateresp);
                toast.success(response.message);

            } else {

                toast.error(response.message);

            }
            setLoading(false)
        }).catch(function (error) {
            setLoading(false)
        })
    };

    // Conditional row style for deleted rows
    const conditionalRowStyles = [
        {
            when: row => row.isDeleted === true,
            style: {
                opacity: 0.4,
                filter: "grayscale(1)"
            }
        }
    ];

    const CustomDeleteModal = ({ isOpen, onClose, onConfirm, beneficiaryName }) => {
        return (
            <Modal
                title="Delete Beneficiary"
                open={isOpen}
                onOk={onConfirm}
                onCancel={onClose}
                okText="Delete"
                okButtonProps={{ danger: true }}
                cancelText="Cancel"
            >
                <p>Are you sure you want to delete <strong>{beneficiaryName}</strong>? This action cannot be undone.</p>
            </Modal>
        );
    };

    const deleteBeneficiary = async (data) => {
        setLoading(true);
        const payload = {
            mobile: saveCustomerMobile,
            bene_id: data.beneId,
            latitude: latitude || "0.0",
            longitude: longitude || "0.0",
            devicetype: "W"
        };
        postRequest(POST_FINO_DELETE_BENEFICIARY, payload, history).then((response) => {
            if (response.success === true) {
                getDataReports();
                toast.success(response.message, {
                    toastId: 'success-delete',
                });
            } else {
                toast.error(response.message, {
                    toastId: 'error-delete',
                });
            }
            setLoading(false);
        }).catch(function (error) {
            setLoading(false);
            toast.error("Error deleting beneficiary", {
                toastId: 'error-delete',
            });
        });
    };

    const ActionCell = ({ row, sendMoney, isSendButtonDisable, deleteBeneficiary, restoreBeneficiary }) => {
        const [showModal, setShowModal] = useState(false);
        const [selectedBeneficiary, setSelectedBeneficiary] = useState(null);

        const handleDeleteClick = (beneficiary) => {
            setSelectedBeneficiary(beneficiary);
            setShowModal(true);
        };

        const handleConfirmDelete = async () => {
            if (selectedBeneficiary) {
                await deleteBeneficiary(selectedBeneficiary);
            }
            setShowModal(false);
            setSelectedBeneficiary(null);
        };

        const handleCloseModal = () => {
            setShowModal(false);
            setSelectedBeneficiary(null);
        };

        // Show restore button for deleted beneficiaries
        if (row.isDeleted) {
            return (
                <Button
                    type="primary"
                    size="small"
                    onClick={() => restoreBeneficiary(row)}
                    style={{
                        background: '#28a745',
                        borderColor: '#28a745',
                        color: 'white'
                    }}
                >
                    Restore
                </Button>
            );
        }

        // Show Send and Delete buttons for active beneficiaries
        return (
            <>
                <Button
                    className={"bg-primary mr-2"}
                    onClick={() => sendMoney(row)}
                    disabled={row.isActive ? isSendButtonDisable : true}
                    small
                >
                    Send
                </Button>
                <Button
                    type="text"
                    danger
                    icon={<DeleteOutlined />}
                    size="small"
                    onClick={() => handleDeleteClick(row)}
                    title="Delete Beneficiary"
                    disabled={row.isDeleted}
                />
                <CustomDeleteModal
                    isOpen={showModal}
                    onClose={handleCloseModal}
                    onConfirm={handleConfirmDelete}
                    beneficiaryName={selectedBeneficiary?.beneName || 'this beneficiary'}
                />
            </>
        );
    };

    const columns = [{
        name: 'Nick Name',
        selector: row => (
            <>
                <div className="d-flex justify-content-between align-items-center">
                    <span>{row.beneName}</span>
                    {row.isDeleted && (
                        <span style={{
                            background: "#dc2626",
                            color: "white",
                            padding: "2px 6px",
                            fontSize: "10px",
                            borderRadius: "4px",
                            marginLeft: "8px"
                        }}>
                            DELETED
                        </span>
                    )}
                </div>
                {row.beneMobile && <div><strong>Mobile</strong>: {row.beneMobile}</div>}
            </>
        ),
        width: "200px",
    }, {
        name: 'IFSC / Bank',
        selector: row => <><div><strong>IFSC</strong>: {row.ifscCode}</div>{row.bankName && <div><strong>Bank</strong>: {row.bankName}</div>}</>,
        width: "200px",
    }, {
        name: 'Account',
        selector: row => <><div>{row.accountNumber}</div><div><strong>UP</strong>: {getUTCToLocalDateFormat(row.updatedAt)}</div></>,
        width: "150px",
    }, {
        name: 'Bene Name',
        selector: row => <><div><strong>{row.isVerified ? <CheckOutlined className='text-120 text-success border p-1' /> : <CloseOutlined className='text-120 text-danger border p-1' />}</strong> {row.beneBankName} </div></>,
        width: "200px",
    },
    // {
    //     name: 'Verified',
    //     selector: row => <>{(row.isVerified) ? <button onClick={() => getName(row, true)} className={`pointer text-success`} disabled={row.isActive ? false : true} >{RE_CHECK}</button> : <button onClick={() => getName(row, false)} className={`pointer text-danger`} disabled={row.isActive ? false : true} >{GET_NAME}</button>}</>,
    //     width: "150px",
    // },
    {
        name: 'Verified',
        selector: row => (
            <>
                {row.isVerified ? (
                    <button
                        onClick={() => getName(row, true)}
                        className="pointer text-success"
                        disabled={!row.isActive}
                    >
                        {RE_CHECK}
                    </button>
                ) : (
                    <button
                        onClick={() => openBankSelection(row)}
                        className="pointer text-danger"
                        disabled={!row.isActive}
                    >
                        {GET_NAME}
                    </button>
                )}
            </>
        ),
        width: "150px",
    },
    {
        name: 'Bene Status',
        selector: row => (
            <div className="flex items-center justify-center">

                <Switch
                    className="custom-switch"
                    checked={row.isActive}
                    onChange={(checked) => beneStatus(row, checked)}
                    size="default"
                    checkedChildren="Active"
                    unCheckedChildren="Inactive"
                    disabled={row.isDeleted}
                />
            </div>
        ),
        width: "250px"
    }, {
        name: 'Amount',
        selector: (row, index) => <><input type='text' name="amount" className="form-control" onChange={(e) => handleEditRowAmount(e, index)} placeholder='Amount' onKeyDown={isNumber} maxLength={5} disabled={row.isActive ? false : true} /></>,
        width: "120px",
    }, {
        name: 'Action',
        selector: (row) => <ActionCell row={row} sendMoney={sendMoney} isSendButtonDisable={isSendButtonDisable} deleteBeneficiary={deleteBeneficiary} restoreBeneficiary={restoreBeneficiary} />,
        width: "200px",
        fixed: "right",
    }
    ];

    useEffect(() => {
        setCustomerMobile(props.customerData && props.customerData.customerMobile);
    }, [props.customerData]) // eslint-disable-line react-hooks/exhaustive-deps

    const beneStatus = (data, status) => {
        let params = {}
        params.id = data._id;
        params.status = status;
        postRequest(UPDATE_DMT_PAY_SPRINT_BENEFICIARY_STATUS, params, history).then((response) => {
            if (response.success === true) {
                getDataReports();
            }
            toast.success(response.message, {
                toastId: 'success1',
            });
        }).catch(function (error) {
            // console.log(error);
        })
    }

    const updateBeneData = (data) => {
        let params = {}
        params.id = data._id;
        params.beneBankName = data.beneBankName;
        postRequest(UPDATE_DMT_PAY_SPRINT_BENEFICIARY_DETAIL, params, history).then((response) => {
            if (response.success === true) {
                getDataReports();
            }
        }).catch(function (error) {
            // console.log(error);
        })
    }

    const getBankList = () => {
        getRequest(GET_DMT_NEW_BANK_LIST, history).then((response) => {
            if (response.success === true) {
                let bankDataRecord
                if (response.data) {
                    bankDataRecord = response.data.filter((item) => item.key === "DMT2.0");
                }
                setEKOBankListData(bankDataRecord);
                setBankListData([...getBankListData, ...bankDataRecord.map((item) => {
                    return { "value": item.BankID, "label": item.BANK_NAME };
                })]);
            }
        }).catch(function (error) {
            // console.log(error);
        })
    }

    const onChangeBankIfscCode = (value) => {
        if (value) {
            let findBank = getEKOBankListData.filter(item => item.BankID === value);
            if (findBank.length > 0) {
                setSelectedOption({ "value": findBank[0].BankID, "label": findBank[0].BANK_NAME });
                if (findBank[0].ifsc) {
                    setBeneData({ ...getBeneData, ifscCode: findBank[0].ifsc });
                    let obj = {}
                    obj.target = { name: "ifscCode", value: findBank[0].ifsc }
                    enterIfscCode(obj);
                    setIfscEnable(true)
                } else {
                    setBeneData({ ...getBeneData, ifscCode: "" });
                    setIfscEnable(false)
                }
                setBankId(findBank[0].BankID);
            } else {
                setBankId(null);
            }

        } else {
            setBankId(null);
            setIfscEnable(false);
            setBeneData({ ...getBeneData, ifscCode: "" });
        }
    }

    const handleEditRowAmount = (event, index) => {

        let array = getData;
        array.docs[index].amount = event.target.value;
        if (event.target.value > 49000) {

            toast.error('Maximum amount allowed is : 49,000', {
                toastId: 'error1',
            });
            setSendButtonDisable(true)
            event.preventDefault();
            return false;

        } else {

            if (event.target.value >= 1000) {
                setSendButtonDisable(false)
            } else {
                setSendButtonDisable(true)
            }
            setData(array);

        }
    }

    const handleAmount = (event) => {
        setSendMoneyAmount(event.target.value)
    }

    const onChangeAddBeneName = async (event) => {
        let { name, value } = event.target;
        if (isAlphabetOnly(value)) {
            setBeneData({ ...getBeneData, [name]: value });
        } else {
            event.preventDefault();
        }
    }

    const enterIfscCode = async (event) => {
        let { name, value } = event.target;
        setBeneData({ ...getBeneData, [name]: value });
        if (isIfscCodeValid(value)) {
            onChangeIfscCode(value);
            setBeneError({ ...getBeneError, "ifscCodeVaild": 1 });
        } else {
            setBeneError({ ...getBeneError, "ifscCodeVaild": 2 });
        }
    }

    const onChangeAddBene = (event) => {
        let { name, value } = event.target;
        setBeneData({ ...getBeneData, [name]: value });
    }

    const sendMoney = (row) => {
        if (!row.amount) {
            toast.error("Amount is empty");
            return false;
        }
        setSendMoneyModal(true)
        row.isChannel = 2;
        setIsSelectedUser(row);

        const payload = {
            customer_id: saveCustomerMobile,
            accountNumber: row.accountNumber,
            ifsccode: row.ifscCode,
            beneAutoId: row._id,
            amount: row.amount,
            channel: row.isChannel,
            latitude: latitude,
            longitude: longitude,
            serviceName: "FINO"
        }
        handleConfirmSubmit(payload);
    }

    const handleConfirmSubmit = (data) => {
        setLoading(true)
        postRequest(`${POST_FINO_CONFIRM_INITIATE_TRANSACTION}`, data, history).then((response) => {
            if (response.success === true) {
                setChargesData(response.data);
            } else {
                toast.error(response.message);
            }
            setLoading(false);
        }).catch(function (error) {
            setLoading(false);
        });
    }

    const handleSyncBeneficiary = () => {
        let payload = { customerMobile: saveCustomerMobile, isSync: true }
        postRequest(`${POST_DMT_PAY_SPRINT_CUSTOMER_INFO}`, payload, history).then((response) => {
            if (response.success === true) {
                getDataReports();
            }
        }).catch(function (error) {

        })
    }

    const handleSave = (data) => {
        if (sendMoneyAmount !== data.amount) {
            toast.error("Amount did not matched.")
        } else {
            const payload = {
                customerMobile: saveCustomerMobile,
                beneId: data.beneId,
                amount: sendMoneyAmount,
                latitude: latitude,
                channel: data.isChannel,
                longitude: longitude,
                serviceName: "FINO",
                instantTransfer: instantTransfer ? 'Y' : 'N',
                devicetype: "W",
                beneAutoId: data._id,
                accountNumber: data.accountNumber,
                ifsc_code: data.ifscCode
            }
            handleSubmit(payload, data);
        }
    }

    const handleSubmit = (data, originalData) => {

        setLoading(true)

        postRequest(`${POST_FINO_SEND_OTP_TRANSACTION}`, data, history).then((response) => {
            if (response.success === true) {
                handleHideModal();

                setOtpCode(null);
                setOtpTransactionModal(true);
                setBeneID(data.beneId);
                setBeneAutoId(originalData._id);
                setReferenceKey(response.data.data.stateresp);
                setChannel(data.channel);
                setAccountNumber(originalData.accountNumber);
                setIfscCode(originalData.ifscCode);
                setTransactionId(response.data.transactionId);
                toast.success(response.message);

            } else {
                toast.error(response.message);
            }
            setLoading(false);
        }).catch(function (error) {
            setLoading(false);
            handleHideModal();
        });
    }

    const generateTransaction = async (data) => {
        if (data) {
            setLoading(true)
            let payload = {
                "transactionId": data.transactionId,
            }
            await postRequest(`${POST_DMT_PAY_SPRINT_GENERATE_TRANSACTION}`, payload, history).then((response) => {
                if (response.success === true) {
                    setTransactionId(data.transactionId)
                    setOtpCode(null);
                    setOtpTransactionModal(true);
                    setReferenceKey(response.data.referenceKey);
                    toast.success(response.message);
                } else {
                    setOtpTransactionModal(false);
                    toast.dismiss();
                    toast.error(response.message);
                }
                setPaymentStatusModal(false);
                setLoading(false);
            }).catch(function (error) {
                setLoading(false);
                handleHideModal();
            });
        } else {
            getDataReports();
            setTransactionStatus("");
            setTransactionStatusText("")
            handleInvoice(transactionData);
        }
    }

    const generateNextTransaction = async () => {

        if (transactionIndex === transactionLength) {
            getDataReports();
            setTransactionStatus("");
            setTransactionStatusText("")
            handleInvoice(transactionData);
        } else {
            await generateTransaction(transactionSlab[transactionIndex]);
        }
    }

    const handlePayment = async () => {
        setLoading(true)
        const payload = {
            customerMobile: saveCustomerMobile,
            beneId: bene_id,
            amount: sendMoneyAmount,
            latitude: latitude,
            channel: channel,
            longitude: longitude,
            serviceName: "FINO",
            devicetype: "W",
            beneAutoId: bene_auto_id,
            instantTransfer: instantTransfer ? 'Y' : 'N',
            otp: otpCode,
            stateresp: referenceKey,
            referenceKey: referenceKey,
            accountNumber: account_number,
            ifsc_code: ifsc_code,
            transactionId: transactionId
        }

        await postRequest(`${POST_FINO_MAKE_TRANSACTION}`, payload, history).then((response) => {
            if (response.success === true) {

                setOtpTransactionModal(false);
                setOtpModal(false);
                handleHideModal();

                handleInvoice(transactionData);

                toast.success(response.message);

            } else {
                setTransactionStatus("1");
                setTransactionStatusText("Failed")
                setOtpTransactionModal(false);
                toast.error(response.message);

                handleInvoice(transactionData);

            }
            setLoading(false);
        }).catch(function (error) {
            setLoading(false);
            handleHideModal();
        });
    }

    const handlePaymentFail = () => {

        const payload = {
            transactionId: transactionId + "A",
        }
        let URL = POST_FINO_TRANSACTION_ENQUIRY;

        postRequest(`${URL}`, payload, history).then((response) => {
            if (response.success === true) {
                toast.success(response.message);
                handleInvoice(transactionData);

                // getDataReports();
            } else {
                toast.error(response.message);
            }
            setLoading(false);
        }).catch(function (error) {
            // console.log(error)
            setLoading(false);
        })

        setTransactionStatus(null);
        setTransactionStatusText(null);
        setPaymentStatusModal(false);
        setOtpTransactionModal(false);
        setOtpModal(false);
        handleHideModal();
    }

    const handleInvoice = (data) => {
        // setInvoiceDataModal(true);
        setTransactionStatus("");
        setTransactionStatusText("")
        setTransactionSlab(null);
        setTransactionData(null);
        setPaymentStatusModal(false)
        setInvoiceData(data);

        history.push(`/dmtinvoice/${data.client_ref_id}`);

    }

    const handleInvoiceModal = () => {
        setInvoiceDataModal(false);
        setPaymentStatusModal(false)
        setImportModal(false);
    }

    const addBane = () => {
        setAddBaneModal(true);
        setBeneData({})
        setDataField({})
    }

    const FormBaneValidate = () => {
        let formValid = true;
        let formObject = {};
        setBeneError({})
        if (getBeneData && getBeneData.length === 0) {
            formValid = false;
        }
        let array = ["name", "mobile", "ifscCode", "accountNumber"];
        array.forEach(element => {
            if (getBeneData[element] === "" || typeof getBeneData[element] === "undefined") {
                formObject[element] = true;
                formValid = false;
            }
        });

        setBeneError(formObject);
        return formValid;
    }

    const addBaneSave = () => {
        if (FormBaneValidate() === true) {
            const payload = {
                customerMobile: saveCustomerMobile,
                recipientMobile: getBeneData.mobile,
                accountNumber: getBeneData.accountNumber,
                ifscCode: getBeneData.ifscCode,
                bankId: bankId,
                recipientName: getBeneData.name,
                beneBankName: getBeneData.beneBankName
            };
            setLoading(true)

            postRequest(`${POST_FINO_ADD_BENEFICIARY_OTP}`, payload, history).then((response) => {
                if (response.success === true) {

                    setOtpModal(true);
                    setOtpReference(response.data.stateresp);
                    toast.success(response.message);

                } else {

                    toast.error(response.message);

                }
                setLoading(false)
            }).catch(function (error) {
                setLoading(false)
            })
        }
    }

    const importBaneficiarySave = (data) => {
        if (data) {
            const payload = data;

            setLoading(true)
            postRequest(`${POST_FINO_ADD_BENEFICIARY}`, payload, history).then((response) => {
                if (response.success === true) {
                    setImportModal(false);
                    if (response.isotp === true) {
                        setOtpModal(true);
                        setOtpReference(response.otpReference);
                    } else {
                        getDataReports();
                        setBeneData({});
                        setAddBaneModal(false)
                    }
                    toast.success(response.message);
                } else {
                    toast.error(response.message);
                }
                setLoading(false)
            }).catch(function (error) {
                setLoading(false)
            })
        }
    }

    const onChangeOtpValue = (value) => {
        setOtpCode(value);
    }

    const handleCustomerVerify = () => {
        if (otpCode) {
            setLoading(true)
            const payload = {
                sstateresp: otpReference,
                otp: otpCode,
                isBeneOtp: true,
                customerMobile: saveCustomerMobile,
                recipientMobile: getBeneData.mobile || recipientMobile,
                accountNumber: getBeneData.accountNumber || account_number,
                ifscCode: getBeneData.ifscCode || ifsc_code,
                bankId: bankId,
                recipientName: getBeneData.name || recipientName,
                beneBankName: getBeneData.beneBankName || beneBankName,
            };

            postRequest(`${POST_FINO_ADD_BENEFICIARY}`, payload, history).then((response) => {
                if (response.success === true) {
                    setOtpModal(false);
                    getDataReports();
                    setBeneData({});
                    setAddBaneModal(false)
                    toast.success(response.message);
                } else {
                    toast.error(response.message);
                }
                setLoading(false)
            }).catch(function (error) {
                setLoading(false)
            })
        } else {
            toast.error("OTP code is required");
        }
    }

    const handleHideModal = () => {
        setSendMoneyModal(false)
        setAddBaneModal(false)
        // setInvoiceDataModal(false)
    };


    const handleHideInvoiceModal = () => {
        setInvoiceDataModal(false);
                //To hide invoice modal and reset invoice data

    };


    const objectToQueryString = (obj) => {
        var str = [];
        for (var p in obj)
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        return str.join("&");
    }

    const params = { page: page, limit: isLimit };

    const getDataReports = (data) => {
        if (data) {
            setLimit(data)
            params.limit = data
        }
        if (searchText) {
            params.search = searchText;
        }
        if (props.customerData && props.customerData.customerMobile) {
            params.customerMobile = props.customerData.customerMobile;
            setCustomerMobile(params.customerMobile)
        }
        const queryString = objectToQueryString(params);
        getRequest(`${GET_FINO_BENEFICIARY_LIST}?${queryString}`, history).then((response) => {
            if (response.success === true) {
                if (response.data.length === 0) {
                    // props.findCustomerInfo()
                } else {
                    setData(response.data);
                }

            } else {
                setPage(1);
            }
        }).catch(function (error) {
            // console.log(error)
        })
    }

    const handlePageChange = page => {
        setPage(page);
    };

    const getName = (data, recheck) => {
        if (data.accountNumber && data.ifscCode) {

            setLoading(true);
            const payload = {
                "ifsccode": data.ifscCode,
                "accountNumber": data.accountNumber,
                "externalRef": refId(13),
                "consent": "Y",
                "pennyDrop": "AUTO",
                "recheck": recheck,
                "latitude": latitude,
                "longitude": longitude
            };

            postRequest(`${GET_CUSTOMER_BANK_NAME_FROM_ACCOUNT_NUMBER}`, payload, history).then((response) => {
                if (response.success === true) {

                    let record = response.data.data;
                    data.beneBankName = record.nameAtBank
                    updateBeneData(data);

                } else {
                    toast.error(response.message);
                }
                setLoading(false);
            }).catch(function (error) {
                setLoading(false);
            });
        }
    }

    const getBankNameFromAccountNumber = () => {
        if (getBeneData.accountNumber && getBeneData.ifscCode) {
            setLoading(true);
            const payload = {
                "ifsccode": getBeneData.ifscCode,
                "accountNumber": getBeneData.accountNumber,
                "externalRef": refId(13),
                "consent": "Y",
                "pennyDrop": "AUTO",
                "latitude": latitude,
                "longitude": longitude
            };
            postRequest(`${GET_CUSTOMER_BANK_NAME_FROM_ACCOUNT_NUMBER}`, payload, history).then((response) => {
                if (response.success === true) {
                    let record = response.data.data;
                    setAadharVerifyModal(true)
                    setAadharVerifyDetail(response.data);
                    let Object = { "beneBankName": record.nameAtBank }
                    setBeneData({ ...getBeneData, ...Object });
                } else {
                    toast.error(response.message);
                }
                setLoading(false);
            }).catch(function (error) {
                setLoading(false);
            });
        } else {
            toast.error("Please enter valid account number")
            let Object = { "name": '' }
            setBeneData({ ...getBeneData, ...Object });
        }
    }

    const onChangeIfscCode = (val = null) => {
        let value;
        if (val) {
            value = val;
        } else {
            value = getBeneData && getBeneData.ifscCode;
        }

        if (isIfscCodeValid(value)) {
            const payload = { "ifsccode": value };
            postRequest(`${IFSC_CODE_VERIFY}`, payload, history).then((response) => {
                if (response.success === true) {
                    let record = response.data.data;
                    let Object = {
                        "ifscCode": record.ifsc,
                        "address": record.address,
                        "bankName": record.bank,
                        "branchAddress": record.branch,
                        "city": record.city,
                        "state": record.state,
                    }
                    setDataField(Object);
                }
            }).catch(function (error) {
            });
        } else {
            if (value && value.length === 11) {
                toast.error("Please enter valid ifsccode")
                let Object = {
                    "address": '',
                    "bankName": '',
                    "branchAddress": '',
                    "city": '',
                    "state": '',
                }
                setDataField(Object);
            }
        }
    }

    const handleSearch = (e) => {
        setSearchText(e.target.value);
    }

    const onChangeChannel = ({ target: { value } }) => {
        let isSelectedUserValue = { ...isSelectedUser };
        isSelectedUserValue.isChannel = value;
        setIsSelectedUser(isSelectedUserValue);
    };

    const onChangeCheckbox = (e) => {
        if (e.target.checked) {
            if (chargesData && parseFloat(chargesData.instantLimit) < isSelectedUser.amount) {
                setInstantTransferError(true);
            } else {
                setInstantTransfer(e.target.checked);
                setInstantTransferError(false);
            }
        } else {
            setInstantTransfer(e.target.checked);
            setInstantTransferError(false);
        }
    };

    useEffect(() => {
        if (timer) {
            clearTimeout(timer)
            setTimer(null)
        }
        setTimer(
            setTimeout(() => {
                getDataReports()
            }, 100)
        )
    }, [searchText]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (props.customerData && props.customerData.customerMobile) {
            getDataReports();
        }
    }, [page, props.handleSearch]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (props.customerData && props.customerData.customerMobile) {
            // getDataReports();
        }
        getBankList();
        // navigator.geolocation.getCurrentPosition((data) => {
        //     setLatitude(data.coords.latitude)
        //     setLongitude(data.coords.longitude)
        // });

        const userData = getUser()
        const shopsLat = userData?.data?.shopsLat;
        const shopsLong = userData?.data?.shopsLong;

        if (
            shopsLat !== undefined &&
            shopsLat !== null &&
            Number(shopsLat) !== 0
        ) {
            setLatitude(Number(shopsLat));
            setLongitude(Number(shopsLong));
        } else {

            navigator.geolocation.getCurrentPosition((data) => {
                setLatitude(data.coords.latitude)
                setLongitude(data.coords.longitude)
            });

        }

    }, [props.customerData]) // eslint-disable-line react-hooks/exhaustive-deps

    const handleImport = () => {
        setImportModal(true);
    }

    if (isLoading) {
        return <div className="content text-center" style={{ margin: "250px 0" }}>
            <PropagateLoader color="#5851D2" loading={isLoading} size={25} />
        </div>
    }

    const confirmCancel = () => {
        Modal.confirm({
            title: "Are you sure you want to cancel?",
            content: "The transaction will be cancelled.",
            okText: "Yes, Cancel",
            cancelText: "No",
            okType: "danger",
            maskClosable: false,
            keyboard: false,
            onOk: () => {
                handlePaymentFail();
            }
        });
    };


    return (
        <div>
            <div className=" pt-2 pb-5">
                <div className="col-md-12">
                    <div className="row pb-3">
                        <div className='col-md-6 date-search'>
                            <div className='row'>
                                <div className="input-group">
                                    <input className="form-control py-2 border-right-0 border" type="search" defaultValue={searchText} value={searchText} onKeyDown={isNumber} placeholder='Search Account Number...' maxLength={20} onChange={(e) => handleSearch(e)} />
                                    <span className="input-group-append">
                                        <button className="btn btn-outline-secondary border-left-0 border" type="button" onClick={() => getDataReports()}>
                                            <i className="fa fa-search" />
                                        </button>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6 p-0'>
                            <div className='float-sm-right'>
                                <button type="button" className="btn btn-primary mr-2" onClick={() => getDataReports()}>
                                    <i className="fa fa-users"></i> Update Beneficiary
                                </button>
                                <button type="button" className="btn btn-primary" onClick={() => addBane()}>
                                    <i className="fa fa-user"></i> Add Beneficiary
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="box-body">
                        <DataTable
                            columns={columns}
                            data={getData.docs}
                            highlightOnHover
                            pagination
                            paginationServer
                            paginationTotalRows={getData.totalDocs}
                            onChangeRowsPerPage={getDataReports}
                            onChangePage={handlePageChange}
                            conditionalRowStyles={conditionalRowStyles}
                        />
                    </div>
                </div>
            </div>
            <ToastContainer position="top-center" autoClose={5000} limit={2} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="colored" />
            {isAddBaneModal && <Modal title={"Add Beneficiary"} width={400} open={isAddBaneModal} onOk={() => addBaneSave()} onCancel={handleHideModal} okText={"Submit"} cancelText={"Cancel"}
                maskClosable={false} keyboard={false}
            >
                <div className='row'>
                    <div className="form-group col-lg-12 col-md-12">
                        <label>Account Holder Mobile</label>
                        <div className="input-group">
                            <div className="custom-file">
                                <input type="text" className="form-control" name="mobile" placeholder="Mobile Number" onChange={(e) => onChangeAddBene(e)} autoComplete="off" value={getBeneData.mobile} maxLength={10} onKeyDown={isNumber} />
                            </div>
                        </div>
                        {getBeneError && getBeneError.mobile && <span className="error text-danger">The field is required</span>}
                    </div>
                    <div className="form-group col-lg-12 col-md-12">
                        <label>Account Holder Name</label>
                        <div className="input-group">
                            <div className="custom-file">
                                <input type="text" className="form-control" name="name" placeholder="Account Holder Name" onChange={(e) => onChangeAddBeneName(e)} autoComplete="off" value={getBeneData && getBeneData.name} maxLength={20} />
                            </div>
                        </div>
                        {getBeneError && getBeneError.name && <span className="error text-danger">The field is required</span>}
                    </div>
                    <div className="form-group col-lg-12 col-md-12">
                        <label>Bank Name</label>
                        <div className="input-group">
                            <div className="custom-file">
                                <Select options={getBankListData} className={`normal-light w-100`} defaultValue={selectedOption} classNamePrefix="select" placeholder="Select Bank" name='mode' onChange={(e) => onChangeBankIfscCode(e.value)} />
                            </div>
                        </div>
                    </div>
                    <div className="form-group col-lg-12 col-md-12">
                        <label>Global IFSC Code</label>
                        <div className="input-group">
                            <div className="custom-file">
                                <input type="text" className="form-control" name="ifscCode" placeholder="Enter IFSC Code" onChange={(e) => enterIfscCode(e)} autoComplete="off" readOnly={isIfscEnable} value={getBeneData.ifscCode} maxLength={11} />
                                <div className="inputgrouptext cursor-pointer text-success" onClick={() => onChangeIfscCode(getBeneData && getBeneData.ifscCode)}>Verify Branch</div>
                            </div>
                        </div>
                        {getBeneError && getBeneError.ifscCode && <span className="error text-danger">The field is required</span>}
                        {getBeneError && getBeneData.ifscCode && getBeneError.ifscCodeVaild === 2 && <span className="error text-danger">The IFSC Code format is not valid</span>}
                        {getBeneError && getBeneError.ifscCodeVaild === 1 && <span className=" text-success">The IFSC Code format is valid</span>}
                    </div>


                    {getDataField && getDataField.address && getDataField.bankName && getDataField.branchAddress && getDataField.city && getDataField.state && <div className="form-group col-lg-12 col-md-12">
                        <div className="custom-file">
                            <ul>
                                <li>Address: <strong>{getDataField.address}</strong></li>
                                <li>Bank Name: <strong>{getDataField.bankName}</strong></li>
                                <li>Branch Address: <strong>{getDataField.branchAddress}</strong></li>
                                <li>City: <strong>{getDataField.city}</strong></li>
                                <li>State: <strong>{getDataField.state}</strong></li>
                            </ul>
                        </div>
                    </div>}
                    <div className="form-group col-lg-12 col-md-12">
                        <label>Account Number</label>
                        <div className="input-group">
                            <div className="custom-file">
                                <input type="text" className="form-control" name="accountNumber" placeholder="Account Number" onChange={(e) => onChangeAddBene(e)} autoComplete="off" value={getBeneData.accountNumber} maxLength={20} onKeyDown={isNumber} />
                                <button className={`inputgrouptext cursor-pointer text-success`} onClick={() => getBankNameFromAccountNumber()} >{GET_NAME}</button>
                            </div>
                        </div>
                        {getBeneError && getBeneError.accountNumber && <span className="error text-danger">The field is required</span>}
                    </div>
                    {getBeneData.beneBankName && <div className="form-group col-lg-12 col-md-12">
                        <label>Bene Bank Name</label>
                        <div className="input-group">
                            <div className="custom-file">
                                <input type="text" className="form-control" readOnly autoComplete="off" value={getBeneData.beneBankName} maxLength={20} />
                            </div>
                        </div>
                    </div>}
                </div>
            </Modal>}

            {isOtpModal && <Modal title={"Customer Verification OTP"} width={600} open={isOtpModal} onOk={() => handleCustomerVerify()} onCancel={() => setOtpModal(false)} okText={"Submit"}

                maskClosable={false} keyboard={false}
            >
                <div className="form-group">
                    <label>OTP Code</label>
                    <div className="input-group">
                        <div className="custom-file">
                            <input type="text" className="form-control" name="otpCode" placeholder="OTP Code" onChange={(e) => onChangeOtpValue(e.target.value)} autoComplete="off" value={otpCode} maxLength={6} onKeyDown={isNumber} />
                        </div>
                    </div>
                </div>
            </Modal>}

            {/* {isOtpTransactionModal && <Modal title={"Transaction OTP Verification"} width={600} open={isOtpTransactionModal} footer={false} >

                <div className="form-group pt-5">
                    <label>OTP Code</label>
                    <div className="input-group">
                        <div className="custom-file">
                            <input type="text" className="form-control" name="otpCode" placeholder="OTP Code" onChange={(e) => onChangeOtpValue(e.target.value)} autoComplete="off" value={otpCode} maxLength={4} onKeyDown={isNumber} />
                        </div>
                    </div>
                </div>
                <div className="form-group pt-2 text-right">
                    <button type='button' className='btn btn-default pointer mr-2' onClick={() => handlePaymentFail()} >Cancel</button>
                    <button type='button' className='btn btn-primary pointer' onClick={() => handlePayment()}>Submit</button>
                </div>
            </Modal>} */}


            {isOtpTransactionModal && (
                <Modal
                    title={"Transaction OTP Verification"}
                    width={600}
                    open={isOtpTransactionModal}
                    footer={false}
                    maskClosable={false}   // prevent outside click close
                    closable={false}       // optional: hide close (X) button
                >
                    <div className="form-group pt-5">
                        <label>OTP Code</label>
                        <div className="input-group">
                            <div className="custom-file">
                                <input
                                    type="text"
                                    className="form-control"
                                    name="otpCode"
                                    placeholder="OTP Code"
                                    onChange={(e) => onChangeOtpValue(e.target.value)}
                                    autoComplete="off"
                                    value={otpCode}
                                    maxLength={4}
                                    onKeyDown={isNumber}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="form-group pt-2 text-right">
                        <button type="button" className="btn btn-default pointer mr-2" onClick={confirmCancel}>
                            Cancel
                        </button>
                        <button type="button" className="btn btn-primary pointer" onClick={handlePayment}>
                            Submit
                        </button>
                    </div>
                </Modal>
            )}


            {isSendMoneyModal && <Modal title={"Money Transfer Verification"} width={600} open={isSendMoneyModal} onOk={() => handleSave(isSelectedUser)} onCancel={handleHideModal} okText={"Continue"} cancelText={"Cancel"}
                maskClosable={false} keyboard={false}
            >
                <div className='row'>
                    <div className='col-md-12 form-group d-flex'>
                        <div className='col-md-8'>
                            <div> Bank Name : <strong>{isSelectedUser.bankName}</strong></div>
                            <div> IFSC Code : <strong>{isSelectedUser.ifscCode}</strong></div>
                            <div> Account Number : <strong>{isSelectedUser.accountNumber}</strong></div>
                            <div> Customer Name : <strong>{isSelectedUser.beneName}</strong></div>
                        </div>
                        <div className='col-md-4'>
                            {chargesData && <><div> Service Charge : <strong>{chargesData.serviceAmount}</strong></div>
                                <div> Commission : <strong>{chargesData.commissionAmount}</strong></div>
                                <div> TDS : <strong>{chargesData.tdsAmount}</strong></div></>}
                        </div>
                    </div>
                    {chargesData && chargesData.instantOption && <div className='col-md-12 form-group'>
                        <Checkbox onChange={onChangeCheckbox} checked={instantTransfer}> Instant Transfer</Checkbox><span className="mt-2">(Remaining Limit: {chargesData.instantLimit})</span>
                    </div>}
                    {instantTransferError && <p className="text-danger">Instant Transfer available limit: {chargesData.instantLimit}</p>}
                    <div className='col-md-12 form-group'>
                        <label>Mode: </label>
                        <br />
                        <Radio.Group defaultValue={2} buttonStyle="solid" onChange={onChangeChannel} value={isSelectedUser.isChannel} optionType="button" >
                            <Radio.Button value={1}> NEFT </Radio.Button>
                            <Radio.Button value={2}> IMPS </Radio.Button>
                        </Radio.Group>
                    </div>
                    <div className='col-md-12 form-group'>
                        <label>Confirm Amount: </label>
                        <input type='text' name="amount" className="form-group form-control" value={sendMoneyAmount} onChange={(e) => handleAmount(e)} onKeyDown={isNumber} maxLength={5} placeholder="Confirm Amount" />
                    </div>
                </div>
            </Modal>}
            {isPaymentStatusModal && <Modal title={"Payment Status"} width={600} open={isPaymentStatusModal} onOk={() => generateNextTransaction()} onCancel={() => handlePaymentFail()} okText={(transactionIndex === transactionLength) ? "Print Invoice" : "Continue"}
                maskClosable={false} keyboard={false}
            >
                <div className="form-group">
                    <h5 className='text-center mt-3'>Transaction : {transactionId}</h5>
                    <div className="text-center my-3">
                        {transactionStatus === "1" && <><div style={{ borderRadius: 200, height: 200, width: 200, background: '#ffe6e6', margin: '0 auto' }}>
                            <b style={{ color: "#e60000" }} className="checkmark">x</b>
                        </div><h1>{transactionStatusText}</h1></>}

                        {transactionStatus === "0" && <><div style={{ borderRadius: 200, height: 200, width: 200, background: '#F8FAF5', margin: '0 auto' }}>
                            <i className="checkmark">✓</i>
                        </div>
                            <h1>{transactionStatusText}</h1>
                        </>}

                        {(transactionStatus !== "0" && transactionStatus !== "1") && <><div style={{ borderRadius: 200, height: 200, width: 200, background: '#ffffb3', margin: '0 auto' }}>
                            <i className="checkmark"><i className="fa fa-clock-o" aria-hidden="true"></i></i>
                        </div>
                            <h1>{transactionStatusText}</h1>
                        </>}
                    </div>
                </div>
            </Modal>}
            {invoiceDataModal && <Modal open={invoiceDataModal} width={800} footer={false} onCancel={handleInvoiceModal} closable={false} maskClosable={false} keyboard={false} >
                <FinoInvoice transactionId={transactionId}

                    onClose={handleHideInvoiceModal}
                />
            </Modal>}
            {importModal && <Modal open={importModal} width={1200} footer={false} onCancel={handleInvoiceModal} closable={true} maskClosable={false} keyboard={false} >
                <ImportBaneficiary mode={"DMT2.0"} customerMobile={saveCustomerMobile} addBaneficiary={importBaneficiarySave} />
            </Modal>}

            {aadharVerifyModal && <Modal title={"Aadhaar Verification Detail"} width={600} open={aadharVerifyModal} onOk={() => { setAadharVerifyDetail({}); setAadharVerifyModal(false) }} onCancel={() => { setAadharVerifyDetail({}); setAadharVerifyModal(false) }} okText={"Ok"} cancelText={"Cancel"} maskClosable={false} keyboard={false}>
                <div className='row'>
                    <div className='col-md-12 form-group'>
                        <div> Name : <strong>{aadharVerifyDetail && aadharVerifyDetail.data && aadharVerifyDetail.data.nameAtBank}</strong></div>
                        <div>{aadharVerifyDetail && aadharVerifyDetail.accountStatus === "VALID" ? <p className="text-bold text-success">{aadharVerifyDetail && aadharVerifyDetail.message}</p> : <p className="text-bold text-danger">{aadharVerifyDetail && aadharVerifyDetail.message}</p>}</div>
                    </div>
                </div>
            </Modal>}


            {showPopup && (
                <div className="popup-overlay">
                    <div className="popup-card">

                        <div className="popup-header">
                            <h3>Verify Beneficiary</h3>
                            <span className="popup-close" onClick={() => setShowPopup(false)}>×</span>
                        </div>

                        <p className="popup-subtitle">Choose bank to proceed with verification</p>

                        <div className="popup-options">
                            <button
                                className="popup-btn"
                                onClick={() => {
                                    setShowPopup(false);
                                    getName(selectedRow, false); // Bank 1
                                }}
                            >
                                Bank 1
                            </button>

                            <button
                                className="popup-btn"
                                onClick={() => {
                                    setShowPopup(false);
                                    getName(selectedRow, true); // Bank 2
                                }}
                            >
                                Bank 2
                            </button>
                        </div>

                    </div>
                </div>
            )}

        </div>
    )
}

export default App;